import angular from 'angular';
import Image from './content-types/image/image';
import Text from './content-types/text/text';
import Tickertape from './content-types/tickertape/tickertape';
import WegBewijzering from './content-types/wegbewijzering/wegbewijzering';
import DisplaySystem from './displaySystem/displaySystem';
import DisplayTemplate from './displayTemplate/displayTemplate';
import TemplateBlock from './template-block/template-block';

let componentsModule = angular.module('app.components', [
  Image,
  Text,
  Tickertape,
  WegBewijzering,
  DisplaySystem,
  DisplayTemplate,
  TemplateBlock
])

.name;

export default componentsModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js